<!--
 * @Author: cjh
 * @LastEditors: chaoluandi chaoluandi@whty.com.cn
 * @Date: 2022-01-11 11:38:33
 * @LastEditTime: 2024-12-10 10:38:18
 * @Description: Modify here please
-->
<template>
    <div class="detail">
      <div class="header">
        <div class="left" @click="toIndex()">< 返回</div>
        <div class="span1">
          <span>课程详情</span>
        </div>
        <div class="right"></div>
      </div>
      <div class="info_header">
        <img :src="info.coverUrl" alt="" />
        <div class="info_header_info">
              <div class="info_header_info_top">
                 <div class="info_header_info_top_left">
                   <p> {{info.cname}} </p>
                    <el-popover
                      placement="bottom-end"
                      width="500"
                      trigger="hover"
                      :content="info.description">
                      <p  class="info_header_info_description" slot="reference">{{info.description}} </p>
                      <!-- <el-button slot="reference">hover 激活</el-button> -->
                    </el-popover>
                   
               </div>
               <div class="info_header_info_top_right">
                     <el-button v-if="introduceState=='0'" icon="el-icon-plus" type="primary" @click="importFun">引入课程</el-button>
                     <el-button v-else icon="el-icon-minus" type="info" @click="importFun">取消引入</el-button>
                </div>  
              </div>
              <div class="info_header_info_bottom">
                 <p>适用年级：{{scope}} </p> 
                 <p>课时总数：{{info.periodTotal}} </p>
                 <div > <span>课次时长：{{info.periodTime}}分钟/次</span> <span class="info_bottom_price"> {{info.price>0?'￥'+info.price:'免费'}}</span> </div> 
              </div>   
          </div>
        </div>
         <div class="detail_item">
             <div class="detail_item_title">
                 <p>课程概述</p>
                 <div class="title_line"></div>
             </div>
             <p class="detail_txt">{{info.supportingDesc}}</p>
         </div>
         <div class="detail_item">
             <div class="detail_item_title">
                 <p>课程设计</p>
                 <div class="title_line"></div>
             </div>
             <div class="detail_item_row">  
               <img src="@/assets/img/system_1.svg" alt="">
               <span class="tip_color">课时总数 :</span> <span>{{info.periodTotal}}节课/学年</span>
             </div>
             <div class="detail_item_row">  
               <img src="@/assets/img/system_2.svg" alt="">
               <span class="tip_color">课程时长:</span> <span>{{info.periodTime}}分钟/节</span>
             </div>
             <div class="detail_item_row">  
               <img src="@/assets/img/system_3.svg" alt="">
               <span class="tip_color">课程目标 :</span> <span class="tip_txt">{{info.objectives}}</span>
             </div>
         </div>
          <div class="detail_item">
             <div class="detail_item_title">
                 <p>课程特点</p>
                 <div class="title_line"></div>
                 <div style="margin-bottom:30px">
                      <div class="detail_item_row">  
                      <img src="@/assets/img/system_4.svg" alt="">
                      <span class="detail_item_row_title">特点一</span>
                    </div>
                    <p class="detail_item_info">{{info.feature}}</p>
                 </div>              
             </div>
         </div>
          <div class="detail_item">
             <div class="detail_item_title">
                 <p>课程资源</p>
                 <div class="title_line"></div>
                 <video
                    v-if="mp4!=''"
                      :src="mp4"
                      controls
                      controlslist="nodownload"
                    ></video>
                    <p class="detail_item_info" v-else>无</p>
             </div>
         </div>
         <div class="detail_item" style="border:0px">
             <div class="detail_item_title">
                 <p>可选配套材料</p>
                 <div class="title_line big"></div>
                 <div class="detail_item_info" title="点击查看" v-for="(j,index) in resourceList " :key="index" @click="previewFile(j)" > {{j.name}} </div>
                 <div  class="detail_item_info" title="点击查看" v-if="resourceList.length==0"> 无</div>
             </div>
         </div>
      </div>
    </div>
</template>
<script>
import educationApi from "@/api/education/index.js";
import dayjs from "dayjs";
import util from "@/utils/util.js";
import { handleMaterialsDetail } from "@/api/mechanismApi/curriculum.js";
import mDetail from "@/views/mechanism/supervise/materialDetail.vue";
export default {
  props: ["info", "introduceState"],
  components: { mDetail },
  data() {
    return {
      visible: false,
      scope:'',//适用年级
      url: require("@/assets/img/test.png"),
      mp4:"",
      resourceList:[]
    };
  },
  computed: {},
  watch: {
    info: {
      async handler(n, o) {
        this.resourceList=[]
        this.scope=util.getGrade(this.info.scope)
         if(n.resource && n.resource.length>0){
             n.resource.forEach(it => {
                if(it.source=='0'){
                  this.mp4=it.previewUrl ||it.downloadUrl
                }else{
                  this.resourceList.push(it)
                }
            });
        }
        // console.log("详情页审核状态__", this.info,this.isResource);
      },
      deep: true,
    },
  },
  created() {},
   mounted() {
    
  },
  methods: {
    dayjs,
    util(){
      return util
    },
    toIndex() {
      this.$emit("to-index");
    },
    previewFile(item) {
      window.open(item.previewUrl || item.downloadUrl);
    },
     importFun: _.throttle(
       function () {
       this.$emit("importFun",this.info);
      //  this.toIndex()
      },
      3000,
      { leading: true, trailing: false }
    ),
  },
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 0px 30px 30px 30px;
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eaeaea;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
      margin-right: 30px;
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
  }
  .info_header {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 191px;
      background: #F5F7F9;
      border-radius: 8px;
      padding:15px;
       img{
          width: 25%;
          height: 161px;
          border-radius: 8px;

         }
      .info_header_info{
          width: 72%;
          .info_header_info_top{
              display: flex;
              justify-content: space-between;
              align-items: center; 
            .info_header_info_top_left{
            p:nth-child(1){
                font-family: 'PingFang SC';
                font-weight: 500;
                font-size: 20px;
                color: #333333;
                margin-bottom: 10px;
            }
            // p:nth-child(2){
            //     width: 500px;
            //     overflow: hidden; /*隐藏*/
            //     white-space: nowrap;  /*不换行*/
            //     text-overflow: ellipsis;  /* 超出部分省略号 */
            //     font-family: 'PingFang SC';
            //     font-weight: 400;
            //     font-size: 14px;
            //     color: #555555;
            // }
            .info_header_info_description{
                width: 500px;
                overflow: hidden; /*隐藏*/
                white-space: nowrap;  /*不换行*/
                text-overflow: ellipsis;  /* 超出部分省略号 */
                font-family: 'PingFang SC';
                font-weight: 400;
                font-size: 14px !important;
                color: #555555;
            }
         }
          }
         .info_header_info_bottom{
          margin-top: 30px;
          p{
            margin-bottom: 10px;
          }
          .info_bottom_price{
             float: right;
             margin-right: 10px;
             color: #EB5757;
          }
         }
      }
    }
   .detail_item{
    padding-bottom: 30px;
    border-bottom: 1px solid #eaeaea;
    margin-top: 3.5%;
      .detail_item_title{
         font-size: 20px;
         color: #0085FF;
         font-weight: 600;
         z-index: 999 !important;
        .title_line{
        width: 80px;
        height: 8px;
        border-radius: 4px;
        background: #DEEDFF;
         z-index: 1 !important;
         &.big{
           width: 120px;
         }
      }
      video{
        width:832px;height:470px;
        margin: 30px;
      }
       .detail_item_info{
        cursor: pointer;
        margin-top: 10px;
          color: #888;font-size: 16px;font-weight: 400;margin-left: 30px;
        }
      }
     .detail_txt{
        margin-top: 15px;
        font-size: 16px;
        color: #222;
     }
     .detail_item_row{
      display: flex;
      align-items: center;
       margin: 15px 0;
          font-size: 16px;
          .tip_color{
              color: #929BA5;
          }
          .tip_txt{
            width: 85%;
            word-wrap:break-word; 
            word-break:break-all; 
            overflow: hidden;/*这个参数根据需求来决定要不要*/
          }
          img ,span{
            margin-right: 10px;
          }
          .detail_item_row_title{
            font-size: 16px;
            color: #222;
          }
     }
   } 
}
</style>
